import type { CreateWeighingInput, PaginatedResult, UpdateWeighingInput, Weighing, WeighingFilterInput } from '@container-system/shared';
import { apiRequest, buildQuery } from './client';

export function listWeighings(filter: Partial<WeighingFilterInput>) {
  return apiRequest<PaginatedResult<Weighing>>(`/api/weighings${buildQuery(filter)}`);
}

export function getWeighing(id: string) {
  return apiRequest<Weighing>(`/api/weighings/${id}`);
}

export function createWeighing(input: CreateWeighingInput) {
  return apiRequest<Weighing>('/api/weighings', { method: 'POST', body: JSON.stringify(input) });
}

export function updateWeighing(id: string, input: UpdateWeighingInput) {
  return apiRequest<Weighing>(`/api/weighings/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export function deleteWeighing(id: string) {
  return apiRequest<null>(`/api/weighings/${id}`, { method: 'DELETE' });
}

export function pairTour(weighingIds: [string, string]) {
  return apiRequest<null>('/api/weighings/tours/pair', { method: 'POST', body: JSON.stringify({ weighingIds }) });
}

export function unpairTour(weighingId: string) {
  return apiRequest<null>(`/api/weighings/tours/${weighingId}/unpair`, { method: 'POST' });
}
